/* eslint-disable react/jsx-handler-names */
import * as topojson from "topojson-client";
import { CustomProjection, Graticule } from "@visx/geo";
import { Zoom } from "@visx/zoom";
import topology from "../scripts/russia-topo.json";
import { TooltipWithBounds, useTooltip } from "@visx/tooltip";
import { localPoint } from "@visx/event";

export type GeoCustomProps = {
  width?: number;
  height?: number;
  events?: boolean;
  regions?: any;
};

interface FeatureShape {
  type: "Feature";
  id: string;
  geometry: { coordinates: [number, number][][]; type: "Polygon" };
  properties: { name: string; level_0: any };
}
export const background = "#fff";
const purple = "#fff";
let tooltipTimer: any;

// @ts-expect-error
const world = topojson.feature(
  // @ts-ignore: Unreachable code error
  topology,
  topology.objects["russia"]
) as {
  type: "FeatureCollection";
  features: FeatureShape[];
};

let device = window.innerWidth;

export default function GeoCustom({
  width = device > 1209 ? (device - 160) / 2 : device,
  height = 350,
  events = true,
  regions,
}: GeoCustomProps) {
  const {
    tooltipData,
    tooltipLeft = 0,
    tooltipTop = 0,
    tooltipOpen,
    showTooltip,
    hideTooltip,
  } = useTooltip<FeatureShape>();

  const centerX = device > 1000 ? 400 : device / 2;
  const centerY = 150;
  const initialScale = (width / 630) * 100;

  return width < 10 ? null : (
    <>
      <Zoom<SVGSVGElement>
        width={width}
        height={height}
        scaleXMin={100}
        scaleXMax={1000}
        scaleYMin={100}
        scaleYMax={1000}
        initialTransformMatrix={{
          scaleX: initialScale,
          scaleY: initialScale,
          translateX: centerX,
          translateY: centerY,
          skewX: 0,
          skewY: 0,
        }}
      >
        {(zoom) => (
          <div className="container">
            <svg
              width={"100%"}
              height={height}
              className={zoom.isDragging ? "dragging" : undefined}
              ref={zoom.containerRef}
              style={{ touchAction: "none" }}
            >
              <rect
                x={0}
                y={0}
                width={width}
                height={height}
                fill={background}
                rx={14}
              />
              <CustomProjection<FeatureShape>
                data={world.features}
                scale={zoom.transformMatrix.scaleX}
                translate={[
                  zoom.transformMatrix.translateX,
                  zoom.transformMatrix.translateY,
                ]}
              >
                {(customProjection) => (
                  <g>
                    <Graticule
                      graticule={(g) => customProjection.path(g) || ""}
                      stroke={purple}
                    />
                    {customProjection.features.map(({ feature, path }, i) => (
                      <path
                        key={`map-feature-${i}`}
                        d={path || ""}
                        fill={`rgba(209, 79, 100, ${
                          regions.find(
                            (item: any) =>
                              item?.threadname == feature?.properties?.name
                          )?.errors_count > 150
                            ? 1
                            : regions.find(
                                (item: any) =>
                                  item?.threadname == feature?.properties?.name
                              )?.errors_count < 10
                            ? 0
                            : 0.5
                        })`}
                        stroke={"#6B7280"}
                        strokeWidth={0.5}
                        onMouseLeave={() => {
                          tooltipTimer = setTimeout(hideTooltip, 150);
                        }}
                        onMouseMove={(e) => {
                          if (tooltipTimer) clearTimeout(tooltipTimer);
                          const { x, y } = localPoint(e) || {
                            x: 0,
                            y: 0,
                          };
                          showTooltip({
                            tooltipData: feature,
                            tooltipLeft: x,
                            tooltipTop: y,
                          });
                        }}
                      />
                    ))}
                  </g>
                )}
              </CustomProjection>

              {/** intercept all mouse events */}
            </svg>
            {tooltipData && (
              <TooltipWithBounds
                key={Math.random()}
                top={tooltipTop}
                left={tooltipLeft}
                data-is-open={tooltipOpen}
                offsetLeft={50}
              >
                {tooltipData.properties.name}:{" "}
                {
                  regions.find(
                    (item: any) =>
                      item?.threadname == tooltipData?.properties?.name
                  )?.errors_count
                }{" "}
                жалоб
              </TooltipWithBounds>
            )}
            <div className="map_legend flex">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="14"
                  height="14"
                >
                  <path
                    d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                    fill="#d14f64"
                    fillOpacity="1"
                    stroke="#ffffff"
                    strokeOpacity="0.9"
                    strokeLinecap="butt"
                    strokeWidth="1"
                    strokeDasharray="0"
                    cx="0"
                    cy="0"
                    //shape="circle"
                    style={{ transform: "translate(50%, 50%)" }}
                  ></path>
                </svg>
                Проблемы с доступом - более 150 жалоб
              </div>
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="14"
                  height="14"
                >
                  <path
                    d="M 0, 0 
           m -7, 0 
           a 7,7 0 1,0 14,0 
           a 7,7 0 1,0 -14,0"
                    fill="rgba(209, 79, 100, 0.5)"
                    fillOpacity="1"
                    stroke="#ffffff"
                    strokeOpacity="0.9"
                    strokeLinecap="butt"
                    strokeWidth="1"
                    strokeDasharray="0"
                    cx="0"
                    cy="0"
                    //shape="circle"
                    style={{ transform: "translate(50%, 50%)" }}
                  ></path>
                </svg>
                Умеренный фон - более 10 жалоб
              </div>
            </div>
          </div>
        )}
      </Zoom>
    </>
  );
}
